import React from 'react';
import { useMenuPulse } from '../menu/useMenuPulse';
import { formatNavFigure } from './format-nav-figure';
import { navIndexMessages } from './nav-index-messages';
import { MOBILE_SUBTITLE_DOT, MOBILE_SUBTITLE_LINE, NAV_PART } from './nav-styles';
import type { PrimaryNavLocale } from '../primary-nav-links';
import type { MenuPulse } from '../../../server/routes/menu-pulse';
import type { IntlShape } from 'react-intl';

/**
 * Mobile top-bar subtitle line under the wordmark (TEC navbar redesign Phase 1): a 6px accent
 * dot + "{open} open jobs · {newToday} new today". Rendered only once the figures have loaded;
 * the wrapper always reserves the line's height so there's no layout shift when they arrive.
 */
export const MobileIndexSubtitle: React.FC<{
  locale: PrimaryNavLocale;
  formatMessage: IntlShape['formatMessage'];
  /** Phase 3 item 3.2: the server-rendered pulse (`pageContext.navPulse`), so this line already
   * has numbers on first paint instead of appearing blank until the client fetch resolves. */
  initialPulse?: MenuPulse | null;
}> = ({ locale, formatMessage, initialPulse }) => {
  const pulse = useMenuPulse(locale, true, initialPulse);
  return (
    <span className={MOBILE_SUBTITLE_LINE} data-jc-nav-part={NAV_PART.mobileSubtitle}>
      {pulse ? (
        <>
          <span className={MOBILE_SUBTITLE_DOT} aria-hidden />
          <span>
            {formatNavFigure(pulse.openJobs, locale)} {formatMessage(navIndexMessages.openJobs)}
            {' · '}
            {formatNavFigure(pulse.newToday, locale)} {formatMessage(navIndexMessages.newToday)}
          </span>
        </>
      ) : null}
    </span>
  );
};
